// Transient messages: every change the server refused. Ported from today's
// pages (components/toasts.tsx), without the undo action.
import { useSyncExternalStore } from 'react'

export interface Toast {
  id: number
  kind: 'info' | 'error'
  text: string
}

let toasts: Toast[] = []
let nextId = 1
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

/** Take every toast away. */
export function clearToasts() {
  if (toasts.length === 0) return
  toasts = []
  emit()
}

export function dismissToast(id: number) {
  if (!toasts.some((t) => t.id === id)) return
  toasts = toasts.filter((t) => t.id !== id)
  emit()
}

/** Show a toast for 4 s, or 8 s for an error; at most four at once. */
export function toast(text: string, kind: Toast['kind'] = 'info'): number {
  const id = nextId++
  toasts = [...toasts.slice(-3), { id, kind, text }]
  emit()
  setTimeout(() => dismissToast(id), kind === 'error' ? 8_000 : 4_000)
  return id
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function Toaster() {
  const list = useSyncExternalStore(subscribe, () => toasts)
  return (
    <div className="toaster" role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`toast toast-${t.kind}`}>
          <span>{t.text}</span>
          <button type="button" className="toast-close" onClick={() => dismissToast(t.id)} aria-label="Dismiss">
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
